import { render, staticRenderFns } from "./QuestionnaireScoreBlock.vue?vue&type=template&id=3f8f734c&scoped=true&"
import script from "./QuestionnaireScoreBlock.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireScoreBlock.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireScoreBlock.vue?vue&type=style&index=0&id=3f8f734c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8f734c",
  null
  
)

export default component.exports